(() => {
  if (window.customElements.get('aspadz-product-feature-tabs')) return;

  class AspadzProductFeatureTabs extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      this.tabs = Array.from(this.querySelectorAll('[data-aspadz-product-feature-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-aspadz-product-feature-panel]'));
      this.descriptions = Array.from(this.querySelectorAll('[data-aspadz-product-feature-description]'));

      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          this.setActive(Number(tab.dataset.featureIndex));
        }, { signal: this.abortController.signal });

        tab.addEventListener('keydown', (event) => {
          this.handleTabKeydown(event);
        }, { signal: this.abortController.signal });
      });

      // Keep block selection useful inside the Shopify theme editor.
      document.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-aspadz-product-feature-panel]');
        if (!panel || !this.contains(panel)) return;
        this.setActive(Number(panel.dataset.featureIndex));
      }, { signal: this.abortController.signal });

      this.setActive(0);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    handleTabKeydown(event) {
      const currentIndex = Number(event.currentTarget.dataset.featureIndex);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;

      if (nextIndex === currentIndex && event.key !== 'Home' && event.key !== 'End') return;

      event.preventDefault();
      this.setActive(nextIndex, true);
    }

    setActive(index, moveFocus = false) {
      const safeIndex = Math.max(0, Math.min(index, this.tabs.length - 1));
      this.style.setProperty('--aspadz-pft-active-index', safeIndex);
      this.dataset.activeIndex = String(safeIndex);

      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === safeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === safeIndex;
        panel.hidden = !isActive;
        if (isActive) this.loadPanelMedia(panel);
      });

      this.descriptions.forEach((description, descriptionIndex) => {
        description.hidden = descriptionIndex !== safeIndex;
      });

      if (moveFocus) this.tabs[safeIndex]?.focus();
    }

    loadPanelMedia(panel) {
      // Delayed source activation avoids downloading inactive tab media.
      panel.querySelectorAll('source[data-srcset]').forEach((source) => {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });
    }
  }

  window.customElements.define('aspadz-product-feature-tabs', AspadzProductFeatureTabs);
})();
